<template>
  <div class="trip-list">

    <div class="card">
      <div class="title-wrap">
        <div class="title">电子质保卡</div>
        <div>{{ imei }}</div>
      </div>
      <div class="timeDate">
        <span></span>
        <div >
          <div class="dateWrap">激活日期：{{warranty_active}}</div>
          <div class="dateWrap">质保有效期：激活后24个月/出厂日期后36个月,以先到为限</div>
          <!-- <div class="dateWrap">质保有效期：{{warranty_period_deadline}}</div> -->
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { getTime } from '../../../assets/js/xjpublic';
export default {
  name: 'warrantyCard',
  data() {
    return {
      warranty_period_deadline:"",
      warranty_active:"",
      imei:""
    }
  },
  methods:{
    getWarrantyDate(){
      this.$axios.post('/v3/u/vehicle/baseInfo',{}).then(res=>{
        if(!res.data.ret){
          const warranty_active = res.data.data.active_time;
           const timestamp = (new Date(warranty_active)).getTime();
          this.warranty_active = timestamp>0?getTime.getFormatDateWithTxt(1,warranty_active):"暂未激活";
          // const timestamp = (new Date(warranty_active)).getTime();
          // if(timestamp>0){
          //   const period =  res.data.data.warranty_period;
          //   const date = new Date(warranty_active);
          //         date.setMonth(date.getMonth()+period)
          //  this.warranty_period_deadline = getTime.getFormatDateWithTxt(1,date)
          // }else{
          //   this.warranty_period_deadline = "设备暂未激活"
          // }

          }
        })
    }
  },
  created () {
    this.imei = this.$cookies.get('imei');
    this.getWarrantyDate()
  }
}
</script>
<style scoped lang="less">
@import "./index.less";
</style>
